<template>
    <div class="dropdown">
        <slot></slot>
    </div>
</template>
